import { render, staticRenderFns } from "./CreateSuppliers.vue?vue&type=template&id=34fa2b79&"
import script from "./CreateSuppliers.vue?vue&type=script&lang=js&"
export * from "./CreateSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./CreateSuppliers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports